import React from "react";
import styled from "styled-components";
import Title from "@airasia/phoenix-components/components/Title";
import Carousel from "@airasia/phoenix-widgets/widgets/Carousel";
import { fireGtmEvent, changeGtmParametersValue } from "../../utils/functions";
import { GTM_PROJECT_CATEGORY } from "../../utils/constants";
import _ from "lodash";

const WidgetWrapper = styled.div`
  margin-top: 2%;

  #titlePromotion {
    font-size: 1.5rem;
    margin-left: 8px;
  }

  @media only screen and (max-width: 720px) {
    margin-left: -16px;
    margin-right: -16px;

    #titlePromotion {
      font-size: 1.25rem;
      margin-left: 16px;
    }
  }
`;

function CarouselWrapper({ carouselData, carouselIndex }) {
  return (
    <WidgetWrapper>
      {carouselIndex === 0 || (
        <Title
          accessible
          inverted={false}
          textAlign="left"
          theme="AIRASIA_CLASSIC"
          type="h2"
          customProperties={{ id: "titlePromotion" }}
        >
          {carouselData.headline}
        </Title>
      )}
      {
        _.isArray(_.get(carouselData, 'card')) ? <Carousel
          accessible
          allowLocaleFormat={true}
          customProperties={{
            'id': carouselData.carousel_id ? carouselData.carousel_id : carouselData.headline
          }}
          data={carouselData?.card?.map((card) => {
            const defaultProps = {
              title: card.title,
              subtitle: card.subtitle,
              url: card.url,
              couponBoxCtaText: card.couponboxctatext,
              couponBoxLabel: card.couponboxlabel,
              cta: card.cta,
              image:
                (card.imagefile ? card.imagefile.url : card.image) +
                "?height=180&quality=90&format=jpg&auto=webp",
              imageAlt: `${card.title} airasia promotion 2025`,
              primaryLabel: card.primarylabel,
              promotionCouponCode: card.promotioncouponcode,
              promotionTnC: card.promotiontnc,
              subtitleExpandCtaText: card.subtitleexpandctatext,
              timerEndDateTime: card.timerlabel.timerenddatetime,
              timerLabelEndDays: card.timerlabel.timerlabelenddays,
              timerLabelEndHours: card.timerlabel.timerlabelendhours,
              timerLabelStartDays: card.timerlabel.timerlabelstartdays,
              timerLabelStartHours: card.timerlabel.timerlabelstarthours,
              timerStartDateTime: card.timerlabel.timerstartdatetime,
              timerTimeZone: card.timerlabel.timertimezone,
            };
            let otherProps = {};
            if (card.others) {
              otherProps = {
                attractText: card.others.attracttext,
                discount: card.others.discount,
                formattedOriginalPriceMob: card.others.formattedoriginalprice,
                formattedOriginalPriceWeb: card.others.formattedoriginalprice,
                formattedPriceMob: card.others.formattedprice,
                formattedPriceWeb: card.others.formattedprice,
                currencyCode: card.others.currencycode,
                hidden: card.others.hidden,
                location: card.others.location,
                newTab: card.others.newtab,
                originalprice: card.others.originalprice,
                price: card.others.price,
                priceClarification: card.others.priceclarification,
                priceDisclaimer: card.others.pricedisclaimer,
                rating: card.others.rating,
                secondaryLabel: card.others.secondarylabel,
                star: card.others.star,
                timer: card.others.timer,
              };
            }
            return {
              ...defaultProps,
              ...otherProps,
            };
          })}
          environment="PRODUCTION"
          fireGtm={(obj) => {
            fireGtmEvent(obj);
          }}
          gtmConsumerName={GTM_PROJECT_CATEGORY}
          heading={{
            cardCount: "5",
            gtmParameters: changeGtmParametersValue(
              carouselData.carousel_gtmparameters,
              carouselIndex
            ),

            layoutName: "lob_widget",
            subHeadline: carouselData.subheadline,
            widgetName: "carousel",
            widgetWidth: "3",
          }}
          isHideFooter={false}
          isLoading={false}
          showMoreTextTarget="self"
          templateType="productCard"
          theme="AIRASIA_CLASSIC"
          widgetName="Carousel"
          lazyLoadImage={true}
          enableProgressiveImageLoading={true}
        /> : null
      }

    </WidgetWrapper>
  );
}

export default CarouselWrapper;
